<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JBDTc5/tc-custom/9781466834309.jpg?1726273316119" alt="This image is the cover for the book Cinnamon Toasted, Spice Shop Mystery Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cinnamon Toasted, Spice Shop Mystery Series
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A mouth-watering entry in Gail Oust's delicious Spice Shop series, Cinnamon Toasted is sure to delight cozy fans of all stripes.</b><br/><br/>Who says you can't teach an old dog new tricks?  Case in point:  Piper Prescott's former mother-in-law Melly.  Beneath her twin sets and pearls beats the heart of a geek—a geek whose programming changes for the point-of-sale software in Piper's shop have the owners of the program ready to make her an offer she can't refuse.  "Trusty" Rusty Tulley and Chip Balboa swing by Brandywine Creek—just in time for the town's annual Oktoberfest, which has cinnamon, cloves, and cardamom flying off Piper's shelves in record numbers. News spreads faster than a text message, and Melly is the toast of the town.<br/><br/>But it isn't long before Melly's status changes to public enemy number one when Chip's body is found at the foot of her basement stairs.  Questions start to pile up when handsome police chief Wyatt McBride arrives on the scene and the coroner sets the time of death for the previous evening.  McBride wants to know why it took Melly so long to report the incident—especially after she admits to arguing with Chip about the contract he wanted her to sign.  Piper knows Melly would never hurt a fly, so she enlists the help of her BFF Reba Mae to clear her name—but can they find the real killer before Melly gets sent away for good?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gail Oust
      </h2>
      
      <p class="authorDescription body article"><P>GAIL OUST is often accused of flunking retirement. Hearing the words "maybe it's a dead body" while golfing fired her imagination for writing a cozy. Ever since then, she has spent more time on a computer than at a golf course. She lives with her husband in McCormick, South Carolina.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4efe9c6b